import { apiEndpoints } from '@/apiEndpoints';
import { CircuitResponse } from '@/types/circuits/CircuitResponse';
import axios, { AxiosError } from 'axios';

export type CircuitDayForImport = {
  stepTitle: string | null;
  images: string[];
  description: string | null;
  CircuitDayStep: CircuitResponse['circuitDays'][number]['CircuitDayStep'];
};

export const getCircuitForImport = async (
  circuitCode: number,
  dayNumber: number,
) => {
  try {
    const result = await axios.get<CircuitDayForImport>(
      apiEndpoints.circuits.import(circuitCode, dayNumber),
    );

    return result.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.status === 404) {
        throw new Error('Étape non trouvée');
      } else {
        throw new Error('Une erreur est survenue');
      }
    }

    throw new Error('Une erreur est survenue');
  }
};
